import Button, { ButtonColor, ButtonProps } from './Button';

export default Button;
export type {
  ButtonColor,
  ButtonProps,
};
